import axios from 'axios';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var PAGE_SIZE = 25;
var AUTOCOMPLETE_PAGE_SIZE = 7;

var constants = {
  __proto__: null,
  PAGE_SIZE: PAGE_SIZE,
  AUTOCOMPLETE_PAGE_SIZE: AUTOCOMPLETE_PAGE_SIZE
};

var AUTH_TOKEN_KEY = 'auth_token';

var BaseApi = function BaseApi(url) {
  var _this2 = this,
      _this3 = this,
      _this4 = this,
      _this5 = this,
      _this6 = this,
      _this7 = this;

  var _this = this;

  this.axiosOverride = function (axios) {
    var Token = _this.getAuthToken();

    axios.defaults.headers.common['Authorization'] = "Token " + Token;
    return axios;
  };

  this.post = function (url, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      return Promise.resolve(_this2.send(url, 'post', params, axiosParams));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this.get = function (url, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      var base_url = _this3.url;

      var newAxios = _this3.axiosOverride(axios);

      return Promise.resolve(newAxios(_extends({
        method: 'get',
        params: params,
        url: "" + base_url + url
      }, axiosParams)));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this.put = function (url, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      return Promise.resolve(_this4.send(url, 'put', params, axiosParams));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this.patch = function (url, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      return Promise.resolve(_this5.send(url, 'patch', params, axiosParams));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this["delete"] = function (url, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      return Promise.resolve(_this6.send(url, 'delete', params, axiosParams));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this.send = function (url, method, params, axiosParams) {
    if (axiosParams === void 0) {
      axiosParams = {};
    }

    try {
      var base_url = _this7.url;

      var newAxios = _this7.axiosOverride(axios);

      return Promise.resolve(newAxios(_extends({
        method: method,
        data: params,
        url: "" + base_url + url
      }, axiosParams)));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  this.url = url;

  this.getAuthToken = function () {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  };

  this.setAuthToken = function (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    return true;
  };

  this.removeAuthToken = function () {
    try {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return true;
    } catch (_unused) {
      return false;
    }
  };
};

export default BaseApi;
export { constants };
//# sourceMappingURL=index.modern.js.map
